import { mediaRef } from '@/services/mediaAssets';

export const axesAndOs = {
  id: 'axes-and-os',
  slug: 'axes-and-os',
  contentType: 'experience',
  name: "Axes & O's",
  category: 'competition',
  date: '',
  summary: 'The Reckon Crew traded keyboards for axes during a local axe-throwing team outing.',
  place: {
    name: "Axes & O's",
    city: 'Sterling',
    state: 'VA',
  },
  heroImage: mediaRef('adventures/other-fun/axes-and-os-sterling-va.png'),
  tags: ['axe-throwing', 'team-building', 'competition', 'indoor', 'local-event'],
  featured: true,
};

export const k1Speed = {
  id: 'k1-speed',
  slug: 'k1-speed',
  contentType: 'experience',
  name: 'K1-Speed',
  category: 'competition',
  date: '',
  summary: 'A local race day that put the Reckon Crew behind the wheel.',
  place: { name: 'K1 Speed' },
  tags: ['racing', 'team-building', 'competition', 'indoor', 'local-event'],
  meritBadgeIds: [],
  featured: false,
};

export const movieNightAlamo = {
  id: 'movie-night-alamo',
  slug: 'movie-night-alamo',
  contentType: 'experience',
  name: 'Movie Night at Alamo',
  category: 'activity',
  date: '',
  summary: 'A relaxed team movie night close to home.',
  place: { name: 'Alamo Drafthouse' },
  tags: ['movies', 'team-connection', 'indoor', 'local-event'],
  meritBadgeIds: [],
  featured: false,
};

export const experiences = [axesAndOs, k1Speed];
export const experiencesBySlug = experiences.reduce((lookup, experience) => ({ ...lookup, [experience.slug]: experience }), {});

export default experiences;
